const getters = {
    theme: state => state.theme,
    lives: state => state.lives,
    banners: state => state.banners,
    kits : state => state.kits,
    locale: state => state.locale,
    kitsCategories : state => Object.keys(state.kits),
    bannerHome : state => state.layoutParts.find( w => w.title == "Banner da Home (não alterar esse título)" ),
    workouts : state => state.workouts.filter( w => w.parent == "" ),
    subWorkouts : state => state.workouts.filter( w => w.parent != "" ),
    activeWorkout : state => state.activeWorkout,
    activeVideo : state => state.activeVideo,
    activeKit : state => state.activeKit,
    streamingLive : state => state.lives.find ( l => l.active == 'yes' ),
    recentVideos: state => state.videos.slice(0,5)
}

export default getters
